import { api } from './apiProvider';

export interface RequestInviteResponse {
  companyName: string;
  companyEmail: string;
}

export interface InviteResponse {
  email: string;
  userExists: boolean;
  customerId: string;
}

interface SignUpRequest {
  inviteToken: string;
  password: string;
}

interface SignInRequest {
  email: string;
  password: string;
  customerId: string | null;
}

export interface AvailableCustomer {
  id: string;
  displayName: string;
}

interface UserContextRequest {
  customerId: string | null;
}

export interface UserContextResponse {
  id: string;
  email: string;
  companyName: string | null;
  companyWebsite: string | null;
  companyId: string;
  customerId: string;
  availableCustomers: AvailableCustomer[];
  roles: string[];
  hints: string[];
  backOfficeRootUrl: string;
}

export interface AuthEmailRequest {
  email: string;
}

export interface PasswordResetRequest {
  email: string;
  token: string;
  password: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

const routeRoot = 'auth';

export async function requestInvite(request: AuthEmailRequest): Promise<RequestInviteResponse> {
  return await api.post(`${routeRoot}/invites`, { json: request }).json<RequestInviteResponse>();
}

export async function getInvite(inviteToken: string): Promise<InviteResponse> {
  return await api.get(`${routeRoot}/invites/${inviteToken}`).json<InviteResponse>();
}

export async function signUp(request: SignUpRequest): Promise<InviteResponse> {
  return await api.post(`${routeRoot}/sign-up`, { json: request }).json<InviteResponse>();
}

export async function signIn(request: SignInRequest): Promise<UserContextResponse> {
  return await api
    .post(`${routeRoot}/sign-in`, {
      json: request,
      credentials: 'include',
    })
    .json<UserContextResponse>();
}

export async function verifyAuth(): Promise<void> {
  await api.get(`${routeRoot}/validate-auth`);
}

export async function refreshContext(request: UserContextRequest): Promise<UserContextResponse> {
  return await api
    .post(`${routeRoot}/refresh-context`, {
      json: request,
      credentials: 'include',
    })
    .json<UserContextResponse>();
}

export async function signOut(): Promise<void> {
  await api.put(`${routeRoot}/sign-out`, { json: {}, credentials: 'include' });
}

export async function requestPasswordReset(request: AuthEmailRequest): Promise<void> {
  await api.post(`${routeRoot}/request-password-reset`, { json: request });
}

export async function resetPassword(request: PasswordResetRequest): Promise<void> {
  await api.post(`${routeRoot}/reset-password`, { json: request });
}

export async function changePassword(request: ChangePasswordRequest): Promise<void> {
  await api.post(`${routeRoot}/change-password`, { json: request, credentials: 'include' });
}
